export default {
    "type": "array",
    "items": {
        "type": "string",
        "enum": ["no","sv","dk","en","it","es"],
        "enumNames": ["Norsk","Svensk","Dansk","Engelsk","Italiensk","Spansk"]
    },
    "uniqueItems": true
}